import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 18l2 1V1H7v2h12v15zM17 5H3v18l7-3 7 3V5z"
}), 'BookmarksSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BookmarksSharp.js
// module id = 2406
// module chunks = 2